import { createSlice } from "@reduxjs/toolkit";
import { ELanguage } from "../../shared/enums/user/ELanguage";
import { ERole } from "../../shared/enums/user/ERole";
import { ETheme } from "../../shared/enums/user/ETheme";
import { IUser } from "../../shared/interfaces/user/IUser";

export interface IAuthState {
  isAuthenticated: boolean;
  token: string;
  userData?: IUser;
}

const initialState: IAuthState = {
  isAuthenticated: false,
  token: "",
  userData: {
    role: ERole.ADMIN,
    id: 0,
    createdAt: "",
    displayName: "",
    updatedAt: "",
    email: "",
    firstName: "",
    theme: ETheme.LIGHT,
    language: ELanguage.GB,
    lastName: "",
    phoneNumber: "",
    unreadNotifications: 0,
  },
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setLoginState: (state, action) => {
      state = action.payload;
      return state;
    },
    setLogoutState: (state) => {
      state = initialState;
      return state;
    },
  },
});

export default authSlice;
